import { render, staticRenderFns } from "./SaleQuotations.vue?vue&type=template&id=3fdc38fc&"
import script from "./SaleQuotations.vue?vue&type=script&lang=js&"
export * from "./SaleQuotations.vue?vue&type=script&lang=js&"
import style0 from "./SaleQuotations.vue?vue&type=style&index=0&id=3fdc38fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports